<template lang="pug">
  a.button.alert(@click="dismiss") Dismiss
</template>

<script>
  import ModalReveal from "../../../foundation/ModalReveal";

  export default {
    name: "DismissAsset",
    components: {ModalReveal},

    methods: {
      dismiss() {

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DismissAsset.vue?636640b6